module.exports = __webpack_public_path__ + "static/Prof.FedikAbdulRantamVMDPhD-583fd33fdf592554ec70258734f085b0.jpg";